export const UNASSIGNED_ERROR = 'UNASSIGNED_ERROR';